import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
// import AppLngSwitcher from "@crema/core/AppLngSwitcher";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
//import AppSearchBar from '@crema/core/AppSearchBar';
import Hidden from "@mui/material/Hidden";
import IconButton from "@mui/material/IconButton";
import { toggleNavCollapsed } from "redux/actions";
import MenuIcon from "@mui/icons-material/Menu";
import { useDispatch } from "react-redux";
// import AppMessages from "../../../AppMessages";
import AppNotifications from "../../../AppNotifications";
// import Menu from "@mui/material/Menu";
// import MenuItem from "@mui/material/MenuItem";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import AppTooltip from "../../../AppTooltip";
import PropTypes from "prop-types";
// import { alpha } from "@mui/material/styles";
import AppLogo from "../../components/AppLogo";
import UserInfo from "../../components/UserInfo";
import { useSidebarContext } from "@crema/utility/AppContextProvider/SidebarContextProvider";
// import AppWeather from "@crema/core/AppWeather";
import ProfileSwitcher from "../../components/ProfileSwitcher";
import Weather from "../../components/Weather";
// import { RoutePermittedRole } from "shared/constants/AppConst";
import { useAuthUser } from "@crema/utility/AuthHooks";
import jwtAxios from "@crema/services/auth/jwt-auth";
import { baseURLAuth } from "shared/constants/AppConst";

const AppHeader = (props) => {
    const { user } = useAuthUser();
    const { sidebarTextColor } = useSidebarContext();
    const { isCollapsed, setCollapsed } = props;

    const handleMoveToBGSM = async () => {
        try {
            const userCode = user?.userCode || user?.uid || "";
            const response = await jwtAxios.post(
                `${baseURLAuth}/move-to-bgsm-default-otp-validation`,
                {
                    userCode: userCode,
                    otp: "",
                }
            );

            const token = response?.data?.token || response?.data?.data?.token;

            if (token) {
                const profileResponse = await jwtAxios.get(
                    `${baseURLAuth}/user-profile-move-to-bgsm`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (
                    profileResponse?.data?.status === "OK" ||
                    profileResponse?.status === 200
                ) {
                      window.location.href = `https://bgsm.org/?token=${token}`;
                    //window.location.href = `http://65.0.186.69:3000/?token=${token}`;
                } else if (profileResponse?.data?.data?.redirectUrl) {
                    window.location.href = profileResponse.data.data.redirectUrl;
                } else if (profileResponse?.data?.redirectUrl) {
                    window.location.href = profileResponse.data.redirectUrl;
                }
            } else if (response?.data?.data?.redirectUrl) {
                window.location.href = response.data.data.redirectUrl;
            } else if (response?.data?.redirectUrl) {
                window.location.href = response.data.redirectUrl;
            }
        } catch (error) {
            console.error("Error in move-to-bgsm flow:", error);
        }
    };

    // const [anchorEl, setAnchorEl] = React.useState(null);

    // const handleClick = (event) => {
    //   setAnchorEl(event.currentTarget);
    // };

    // const handleClose = () => {
    //   setAnchorEl(null);
    // };
    const dispatch = useDispatch();

    return (
        <AppBar
            position="relative"
            color="inherit"
            sx={{
                boxShadow: "0px 1px 5px 2px rgba(0, 0, 0, 0.06)",
                // borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                borderBottm: "0",
                backgroundColor: "background.paper",
                transition: "width 0.3s ease",
                width: "100%",
            }}
            className="app-bar"
        >
            <Toolbar
                sx={{
                    boxSizing: "border-box",
                    minHeight: { xs: 56, sm: 70 },
                    paddingLeft: { xs: 5 },
                    paddingRight: { xs: 5 },
                }}
            >
                <Hidden lgDown>
                    <IconButton
                        sx={{
                            color: "text.secondary",
                            backgroundColor: "rgba(0, 0, 0, 0.09)",
                        }}
                        // edge="start"
                        className="menu-btn"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={() => setCollapsed(!isCollapsed)}
                        size="large"
                    >
                        <MenuIcon />
                    </IconButton>
                </Hidden>
                <Hidden lgUp>
                    <IconButton
                        sx={{
                            color: "text.secondary",
                            backgroundColor: "rgba(0, 0, 0, 0.09)",
                        }}
                        // edge="start"
                        className="menu-btn"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={() => dispatch(toggleNavCollapsed())}
                        size="large"
                    >
                        <MenuIcon />
                    </IconButton>
                </Hidden>
                <Box
                    sx={{
                        "& .logo-text": {
                            display: { xs: "none", sm: "block" },
                        },
                    }}
                >
                    <AppLogo />
                </Box>
                <Box
                    sx={{
                        flexGrow: 1,
                    }}
                />
                {/* <Box
          sx={{
            minHeight: 40,
            position: "relative",
            "& .searchRoot": {
              position: { xs: "absolute", sm: "relative" },
              right: { xs: 0, sm: "auto" },
              top: { xs: 0, sm: "auto" },
            },
          }}
        >
            <AppSearchBar iconPosition='right' placeholder='Search…' />
        </Box> */}

                {/* <Box sx={{ ml: 4 }}>
          <AppLngSwitcher iconOnly={true} tooltipPosition="bottom" />
        </Box> */}

                <Box sx={{ ml: 4 }}>
                    {/* <Hidden smDown> */}
                    <Box
                        sx={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            // marginLeft: -2,
                            // marginRight: -2,
                        }}
                    >
                        <Hidden mdDown>
                            <Box
                                sx={{
                                    px: 1.85,
                                }}
                            >
                                <Weather />
                            </Box>
                        </Hidden>
                        <Box
                            sx={{
                                px: 1.85,
                            }}
                        >
                            <AppNotifications />
                        </Box>
                    </Box>
                </Box>
                <Box sx={{ mr: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleMoveToBGSM}
                    >
                        Go To BGSM
                    </Button>
                </Box>
                {/* {user.role !== RoutePermittedRole.SUPER_ADMIN && ( */}
                    <Box>
                        <ProfileSwitcher color={sidebarTextColor} />
                    </Box>
                {/* )} */}
                <Box>
                    <UserInfo color={sidebarTextColor} />
                </Box>
            </Toolbar>
        </AppBar>
    );
};
export default AppHeader;

AppHeader.propTypes = {
    isCollapsed: PropTypes.bool,
    setCollapsed: PropTypes.func,
};
